import React, {createContext, ReactNode, useEffect} from 'react';
import { Button, message, Space } from 'antd';
import {AuthContext} from "../../auth/AuthContext";


export let ToastContext = createContext(null);
export default function ToastProvider({ children }: { children: ReactNode }){

    const [messageApi, contextHolder] = message.useMessage();
    //show only one message at a time
  const currentToast = React.useRef(null);


    const success = (message:string) => {
        if (currentToast.current) {
            return;
        }
       currentToast.current = messageApi.open({
            type: 'success',
            content: message,
           onClose: () => {
               currentToast.current = null;
           }
        });
    };

    const error = (message:string, duration:int = 5) => {
        if (currentToast.current) {
            return;
        }
        currentToast.current = messageApi.open({
            type: 'error',
            duration: duration,
            content: message,
            onClose: () => {
                currentToast.current = null;
            }
        });



    };

    const warning = (message:string) => {
        if (currentToast.current) {
            return;
        }
        currentToast.current =  messageApi.open({
            type: 'warning',
            content: message,
            onClose: () => {
                currentToast.current = null;
            }
        });
    };


    let value = {
        success,
        error,
        warning
    }
    // return ( <>
    //     {contextHolder}
    //     <Space>
    //         <Button onClick={success}>Success</Button>
    //         <Button onClick={error}>Error</Button>
    //         <Button onClick={warning}>Warning</Button>
    //     </Space>
    // </>);
return <ToastContext.Provider value={value}>{contextHolder}{children}</ToastContext.Provider>


}